import { Wallet, Smartphone, Zap, Handshake, Target, ShieldCheck } from "lucide-react";
import { Reveal, Overline } from "./Reveal";

const CARDS = [
  { icon: Wallet, title: "Valorise tes opportunités", desc: "Un besoin que tu ne peux pas traiter a de la valeur.", span: "lg:col-span-7" },
  { icon: Smartphone, title: "Depuis ton smartphone", desc: "Dépose tes opportunités directement depuis l'application Leadzi CHR.", span: "lg:col-span-5" },
  { icon: Zap, title: "Quelques minutes suffisent", desc: "Pas besoin de chercher toi-même une solution ou un fournisseur.", span: "lg:col-span-5" },
  { icon: Handshake, title: "Reste utile à ton client", desc: "Même lorsque ton entreprise ne propose pas la solution, tu contribues à trouver une réponse à son besoin.", span: "lg:col-span-7" },
  { icon: Target, title: "Des opportunités qualifiées", desc: "Leadzi analyse les opportunités transmises avant de faire une proposition.", span: "lg:col-span-6" },
  { icon: ShieldCheck, title: "Un fonctionnement simple", desc: "Tu déposes, Leadzi analyse et te rémunère.", span: "lg:col-span-6" },
];

export const WhyLeadzi = () => {
  return (
    <section id="why" className="scroll-mt-20 bg-[#FAFAFA] py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="max-w-3xl">
          <Overline>Pourquoi Leadzi ?</Overline>
          <h2 className="mt-5 font-display text-3xl font-extrabold tracking-tight text-ink sm:text-4xl lg:text-[2.75rem] lg:leading-[1.1]">
            De bonnes raisons d'utiliser Leadzi.
          </h2>
        </Reveal>

        <div data-testid="why-leadzi-bento-grid" className="mt-12 grid grid-cols-1 gap-5 lg:grid-cols-12 lg:gap-6">
          {CARDS.map((c, i) => (
            <Reveal key={c.title} delay={(i % 2) * 0.08} className={c.span}>
              <div className="group relative flex h-full flex-col justify-between overflow-hidden rounded-3xl border border-black/5 bg-white p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_24px_50px_-20px_rgba(13,15,18,0.15)] lg:p-8">
                <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-ink text-white transition-colors group-hover:bg-brand">
                  <c.icon className="h-6 w-6" />
                </span>
                <div className="mt-8">
                  <h3 className="text-xl font-bold text-ink">{c.title}</h3>
                  <p className="mt-2 max-w-md text-sm leading-relaxed text-ink/55">{c.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
